import * as FileSaver from 'file-saver';
import XSLX from 'sheetjs-style';

const ExcelExport = ({ excelData, fileName, className = 'btn btn-outline-secondary btn-app' }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToExcel = async () => {
        const ws = XSLX.utils.json_to_sheet(excelData);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XSLX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return (
        <button type="button" className={className} onClick={exportToExcel} title="Excel'e aktar">
            <i className='bi bi-file-earmark-excel' aria-hidden="true" />
            <span>Excel</span>
        </button>
    );
}

export default ExcelExport;